import { Button, CloseButton, Form } from 'react-bootstrap';
import './PermissionDrawer.css';
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getAllOfficerList, getAllPermissions, getAllRoles } from '../../../../redux/UserReducer/action';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getAuthToken } from "../../../../utils/auth";

const diffPermissions = ({
    existing = [],
    selected = [],
}) => {
    const existingSet = new Set(existing);
    const selectedSet = new Set(selected);

    const toGrant = selected.filter(p => !existingSet.has(p));
    const toRevoke = existing.filter(p => !selectedSet.has(p));

    return { toGrant, toRevoke };
};

const PermissionDrawer = ({ user, onClose, currentPage, limit, role, roleFilters, officerFilters }) => {

    const { permissions } = useSelector((store) => {
        return {
            permissions: store.UserReducer.permissions
        }
    }, []);

    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const [selectedPermissions, setSelectedPermissions] = useState(new Set());
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);
    const [rolePermissionCodes, setRolePermissionCodes] = useState(new Set());

    console.log({ rolePermissionCodes })

    useEffect(() => {
        dispatch(getAllPermissions(1, 100000, {
            is_active: true
        }));

        if (!user?.permissions_details?.role_permissions) {
            setRolePermissionCodes(new Set());
            return;
        }

        setRolePermissionCodes(
            new Set(
                user?.permissions_details?.role_permissions?.map(
                    p => p
                )
            )
        );
    }, [user, dispatch]);

    useEffect(() => {
        if (user?.permissions) {
            setSelectedPermissions(
                new Set(user?.permissions.map(p => p.permission_id))
            );
        }
        // if (user) {
        //     setSelectedPermissionIds(
        //         user?.permissions?.map(p => p.permission_id)
        //     );
        // }
    }, [user]);

    useEffect(() => {
        if (role?.permissions) {
            setSelectedPermissions(
                new Set(role?.permissions.map(p => p.permission_id))
            );
        }
    }, [role]);

    let permissionsByModule = permissions?.reduce((acc, permission) => {
        const moduleName = permission.module_name;

        if (!acc[moduleName]) {
            acc[moduleName] = [];
        }

        acc[moduleName].push(permission);

        return acc;
    }, {});

    // console.log({ permissionsByModule });

    const isPermissionDisabled = (permission) => {
        if (user) {
            return rolePermissionCodes?.has(String(permission.permission_code)) || isBranchDashboardRestrictedForUser(permission);
        }
        if (role) {
            return isBranchDashboardRestrictedForRole(permission);
        }
        return false;
    };

    const getEnabledPermissions = () => {
        return permissions?.filter(permission => !isPermissionDisabled(permission)) || [];
    };

    const getEnabledPermissionsForModule = (modulePermissions) => {
        return modulePermissions?.filter(permission => !isPermissionDisabled(permission)) || [];
    };

    const handleSelectAllGlobal = () => {
        const enabled = getEnabledPermissions();
        const allEnabledSelected = enabled.length > 0 && enabled.every(p => selectedPermissions.has(p.permission_id));
        
        setSelectedPermissions(prev => {
            const updated = new Set(prev);
            if (allEnabledSelected) {
                enabled.forEach(p => updated.delete(p.permission_id));
            } else {
                enabled.forEach(p => updated.add(p.permission_id));
            }
            return updated;
        });
    };

    const handleSelectAllModule = (modulePermissions, allSelected) => {
        const enabled = getEnabledPermissionsForModule(modulePermissions);
        
        setSelectedPermissions(prev => {
            const updated = new Set(prev);
            if (allSelected) {
                enabled.forEach(p => updated.delete(p.permission_id));
            } else {
                enabled.forEach(p => updated.add(p.permission_id));
            }
            return updated;
        });
    };

    const handlePermissionToggle = (permissionId) => {
        setSelectedPermissions(prev => {
            const updated = new Set(prev);

            if (updated.has(permissionId)) {
                updated.delete(permissionId);
            } else {
                updated.add(permissionId);
            }

            return updated;
        });
    };

    const renderPermissionsList = () => {
        if (!permissionsByModule) return null;

        const enabledPermissions = getEnabledPermissions();
        const allEnabledSelected = enabledPermissions.length > 0 && enabledPermissions.every(p => selectedPermissions.has(p.permission_id));

        return (
            <>
                <div className="global-select-all mb-3">
                    <Form.Check
                        type="checkbox"
                        id="select-all-global"
                        label={<strong>Select All Permissions</strong>}
                        checked={allEnabledSelected}
                        onChange={handleSelectAllGlobal}
                        disabled={enabledPermissions.length === 0}
                    />
                </div>

                <div className="permissions">
                    {Object.entries(permissionsByModule).map(([moduleName, modulePermissions]) => {
                        const enabledModulePermissions = getEnabledPermissionsForModule(modulePermissions);
                        const allEnabledModuleSelected = enabledModulePermissions.length > 0 && enabledModulePermissions.every(p => selectedPermissions.has(p.permission_id));

                        return (
                            <div key={moduleName} className="module-section">
                                <div className="module-header d-flex justify-content-between align-items-center mt-3 mb-2">
                                    <h6 className="m-0">{moduleName}</h6>
                                    {enabledModulePermissions.length > 0 && (
                                        <Form.Check
                                            type="checkbox"
                                            id={`select-all-${moduleName}`}
                                            label={<span className="select-all-label">Select All</span>}
                                            checked={allEnabledModuleSelected}
                                            onChange={() => handleSelectAllModule(modulePermissions, allEnabledModuleSelected)}
                                        />
                                    )}
                                </div>

                                {modulePermissions.map(permission => {
                                    const disabled = isPermissionDisabled(permission);
                                    return (
                                        <Form.Check
                                            key={permission.permission_code}
                                            label={permission.permission_code}
                                            checked={selectedPermissions.has(permission.permission_id)}
                                            onChange={() => handlePermissionToggle(permission.permission_id)}
                                            disabled={disabled}
                                        />
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </>
        );
    };

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-type': 'application/json'
    }

    const grantPermissions = async (payload) => {
        return axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/administration/officer-permissions/grant`, 
            payload,
            { headers }
        );
    }

    const revokePermissions = async (payload) => {
        return axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/administration/officer-permissions/revoke`, 
            payload,
            { headers }
        );
    }

    const handleSavePermissions = async () => {
        setSaving(true);

        try {
            if (!authToken) {
                toast.error(`Missing or invalid authentication token`);
                return;
            }

            const officerId = user.officer_id;

            const existingPermissionsIds =
                user.permissions.map(p => p.permission_id);

            // const selectedPermissions = selectedPermissionIds; // from checkbox / table state
            const selectedPermissionsIds = Array.from(selectedPermissions); // from checkbox / table state

            const { toGrant, toRevoke } = diffPermissions({
                existing: existingPermissionsIds,
                selected: selectedPermissionsIds,
            });

            const requests = [];

            if (toGrant.length) {
                requests.push(
                    grantPermissions(
                        toGrant.map(permissionId => ({
                            officer_id: officerId,
                            permission_id: permissionId,
                            valid_days: 15000,
                        }))
                    )
                );
            }

            if (toRevoke.length) {
                requests.push(
                    revokePermissions(
                        toRevoke.map(permissionId => ({
                            officer_id: officerId,
                            permission_id: permissionId,
                        }))
                    )
                );
            }

            await Promise.all(requests);

            // ✅ Refresh officer data
            dispatch(getAllOfficerList(currentPage, limit, officerFilters));
            onClose();

            toast.success("Permissions updated successfully");
        } catch (err) {
            console.error(err);
            toast.error("Failed to update permissions");
        }
        finally {
            setSaving(false);
        }
    };


    const assignPermissionsToRole = async (payload) => {
        return axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/administration/role-permissions/assign`, 
            payload,
            { headers }
        );
    }

    // const removePermissionsFromRole = async (payload) => {
    //     console.log({ headers, payload });
    //     return axios.delete(
    //         `${process.env.REACT_APP_API_BASE_URL}/administration/role-permissions/remove`, 
    //         payload,
    //         { headers }
    //     );
    // }
    const removePermissionsFromRole = async (payload) => {
        return axios.delete(
            `${process.env.REACT_APP_API_BASE_URL}/administration/role-permissions/remove`, 
            {
                headers,
                data: payload
            }
        );
    }

    const handleSaveRolePermissions = async () => {
        setSaving(true);

        try {
            if (!authToken) {
                toast.error(`Missing or invalid authentication token`);
                return;
            }

            const roleId = role.role_id;

            const existingPermissionsIds =
                role.permissions.map(p => p.permission_id);

            const selectedPermissionsIds = Array.from(selectedPermissions); // from checkbox / table state

            const { toGrant, toRevoke } = diffPermissions({
                existing: existingPermissionsIds,
                selected: selectedPermissionsIds,
            });

            const requests = [];

            let payload = {
                role_id: roleId
            };
            if (toGrant.length) {
                payload = {
                    ...payload,
                    permission_ids: toGrant.map(permissionId => Number(permissionId))
                }
                requests.push(
                    assignPermissionsToRole(payload)
                );
            }

            if (toRevoke.length) {
                payload = {
                    ...payload,
                    permission_ids: toRevoke.map(permissionId => Number(permissionId))
                }

                requests.push(
                    removePermissionsFromRole(payload)
                );
            }


            await Promise.all(requests);

            // Refresh role data
            dispatch(getAllRoles(currentPage, limit, roleFilters));
            onClose();

            toast.success("Permissions updated successfully");
        } catch (err) {
            console.error(err);
            toast.error("Failed to update permissions");
        }
        finally {
            setSaving(false);
        }
    };
    // console.log({ user, permissionsByModule, role });

    // const allowedBranchDashboardRoles = ["BM", "BCM", "RO", "HO", "ADMIN"];
    const allowedBranchDashboardRoles = ["BM", "BCM", "RO"];

    const isBranchDashboardRestrictedForUser = (permission) => {
        return (
            permission.module_name === "BRANCH_MANAGEMENT" &&
            // !allowedBranchDashboardRoles.includes(user?.role?.short_name || user?.branch_code) 
            !allowedBranchDashboardRoles.includes(user?.role?.short_name) 
        );
    };

    const isBranchDashboardRestrictedForRole = (permission) => {
        return (
            permission.module_name === "BRANCH_MANAGEMENT" &&
            !allowedBranchDashboardRoles.includes(role?.short_name) 
        );
    };

    if (!user && !role) return null;

    return (
        <div className="permission-drawer-overlay open" onClick={onClose}>
            <div className="permission-drawer open" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-header">
                    <span className='drawer-title'>{user ? "User" : "Role"} Permissions</span>
                    <Button
                        size="sm"
                        variant='ghost'
                        onClick={onClose}
                        className="close-drawer-btn"
                    >
                        <IoMdClose size={"18px"} />
                    </Button>
                </div>

                {user && (
                    <>
                        <div className="drawer-content">
                            <div className="drawer-user">
                                <strong>{[user?.first_name, user?.last_name]?.join(' ')}</strong><br />
                                <small>{user?.email}</small>
                            </div>

                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>ROLE</Form.Label>
                                    <Form.Control
                                        type="text"
                                        defaultValue={user?.role?.role_name}
                                        placeholder="Enter role"
                                        readOnly
                                    />
                                </Form.Group>

                                {renderPermissionsList()}
                            </Form>
                        </div>

                        <div className="drawer-actions">
                            <Button
                                className='secondary-action'
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='primary-action'
                                onClick={handleSavePermissions}
                                disabled={saving}
                            >
                                {saving ? "Saving..." : "Save Changes"}
                            </Button>
                        </div>
                    </>
                )}

                {role && (
                    <>
                        <div className="drawer-content">
                            <div className="drawer-user">
                                <strong>{role?.short_name}</strong><br />
                                <small>{role?.role_name}</small>
                            </div>

                            <Form>
                                <Form.Group className="mb-3">
                                </Form.Group>

                                {renderPermissionsList()}
                            </Form>
                        </div>

                        <div className="drawer-actions">
                            <Button
                                className='secondary-action'
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='primary-action'
                                onClick={() => {
                                    if(user){
                                        handleSavePermissions();
                                    }
                                    else if(role){
                                        handleSaveRolePermissions()
                                    }
                                }}
                                disabled={saving}
                            >
                                {saving ? "Saving..." : "Save Changes"}
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PermissionDrawer;
